import { render, staticRenderFns } from "./toMyGroupChangeManage.vue?vue&type=template&id=42bbcf18&scoped=true&"
import script from "./toMyGroupChangeManage.vue?vue&type=script&lang=js&"
export * from "./toMyGroupChangeManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42bbcf18",
  null
  
)

export default component.exports